<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>

import './config/reset.css'
import '../static/css/style.css'

import api from './api/api'
import Vue from 'vue'

export default {
  beforeCreate () {
    api._setApp(this)
  },
  methods: {

  },
  created () {
  }
}
</script>

<style>
#app {
  font-family: Helvetica, sans-serif;
}
</style>



// WEBPACK FOOTER //
// src/App.vue